<script setup lang="ts">
import { computed, onBeforeMount, storeToRefs } from '#imports';
import { useFooterStore } from './../store';

const footerStore = useFooterStore();
const { text } = storeToRefs(footerStore);
const { getFooterContent } = footerStore;

onBeforeMount(async () => {
	await getFooterContent();
});

const tippyContent = 'Вся информация, размещенная на данном портале, предназначена только для использования в научных целях. При полном или частичном копировании материала ссылка на первоисточник обязательна. Медиаконтент (иллюстрации, фотографии, карты, скан образы) может быть использован только с разрешения правообладателей';

const tippyConfig = computed(() => ({
	content: tippyContent,
	maxWidth: 447,
	interactive: true,
}));
</script>

<template>
	<footer class="footer">
		<div class="footer__container container">
			<div class="footer__block footer__block--note">
				<v-message>
					Этот сайт использует cookies исключительно для аутентификации пользователей. Продолжая пользоваться сайтом, вы соглашаетесь на использование cookies. При желании вы можете отключить их в настройках вашего браузера.
				</v-message>
			</div>

			<div class="footer__block">
				<div class="footer__text" v-html="text" />

				<p class="footer__text">
					Все права защищены. <u v-tippy="tippyConfig">Условия использования информации.</u>
				</p>
			</div>
		</div>
	</footer>
</template>

<style lang="scss" scoped>
.footer {
	&__container {
		display: flex;
		flex-direction: column;
		gap: rem($gap-small);

		@media #{$screen-tablet} {
			align-items: center;
			flex-direction: row-reverse;
			justify-content: space-between;
		}
	}

	&__block {
		@media #{$screen-tablet} {
			flex: 1;
		}

		&--note {
			@media #{$screen-tablet} {
				display: flex;
				justify-content: flex-end
			}
		}
	}

	&__text {
		@include text-miniature;

		@media #{$screen-laptop} {
			@include text-mini;
		}
	}
}
</style>
